<template>
  <AccountSetup />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccountSetup from "@/components/Account/setup/AccountSetup.vue";

const componentName = "AccountSetupRoute";

export default defineComponent({
  name: componentName,
  components: { AccountSetup },
});
</script>
